export default class Chat {
    constructor() {
		this.chatForm = document.getElementById("chat-form");
		this.chatCta = document.getElementById("chat-cta");
		this.chatButton = document.getElementById("chat-button");
		this.chatButtonText = this.chatButton?.innerHTML ?? "";
		this.init();
	}

	init() {
		let cookieChatCta = this.getCookie("chatCta");
		if (cookieChatCta) {
			if (cookieChatCta === "false") {
				setTimeout(() => {
					this.chatCta?.classList.remove("invisible");
					this.chatCta?.classList.remove("opacity-0");
					this.chatCta?.classList.add("opacity-100");
					this.chatCta?.classList.add("-translate-y-6");
				}, 5000);
			}
		} else {
			this.setCookie("chatCta", "false", 1);
		}

		if (this.chatButton) {
			this.chatButton.addEventListener("click", this.toggleChat.bind(this));
		}

		if (this.chatCta) {
			this.chatCta.getElementsByTagName("a")[0].addEventListener("click", (e) => {
				e.preventDefault();
				this.closeChatCta();
			});
		}
	}

	toggleChat(event) {
		event.preventDefault();
		this.chatForm?.classList.toggle("invisible");
		this.chatForm?.classList.toggle("opacity-100");
		this.chatForm?.classList.toggle("-translate-y-6");

		this.closeChatCta();

		if (this.chatButton) {
			this.chatButton.classList.toggle("w-44");
			this.chatButton.classList.toggle("w-12");
			this.chatButton.classList.toggle("left-4");
			if (!this.chatForm?.classList.contains("invisible")) {
				this.chatButton.innerHTML = '<i class="fa-sharp fa-solid fa-xmark fa-xl"></i>';
			} else {
				setTimeout(() => {
					if (this.chatButton) {
						this.chatButton.innerHTML = this.chatButtonText;
					}
				}, 300);
			}
		}
	}

	closeChatCta() {
		this.chatCta?.classList.add("invisible");
		this.chatCta?.classList.add("opacity-0");
		this.chatCta?.classList.remove("opacity-100");
		this.chatCta?.classList.remove("-translate-y-6");
		this.setCookie("chatCta", "true", 1);
	}

	setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	getCookie(cname) {
		let name = cname + "=";
		let ca = document.cookie.split(";");
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == " ") {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
}